import { render, staticRenderFns } from "./OpportunityDashboard.vue?vue&type=template&id=113b5f55&scoped=true&"
import script from "./OpportunityDashboard.vue?vue&type=script&lang=js&"
export * from "./OpportunityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDashboard.vue?vue&type=style&index=0&id=113b5f55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b5f55",
  null
  
)

export default component.exports